/**
 * Per-tab article state in `sessionStorage`. Surfaces errors as false/no-op when storage is blocked.
 */

/** Legacy value written before intent-gate flow (treat as full modal opened). */
const VALUE_LEGACY_SEEN = 'seen';
/** Full-page quiz modal was entered (Take the Quiz). */
const VALUE_OPENED = 'opened';
/** Intent gate was dismissed without opening the full modal. */
const VALUE_DECLINED = 'declined';

function getRaw(storageKey: string): string | null {
  try {
    return sessionStorage.getItem(storageKey);
  } catch {
    return null;
  }
}

function isOpenedValue(v: string | null): boolean {
  return v === VALUE_OPENED || v === VALUE_LEGACY_SEEN;
}

/** True if init should not run: full modal was opened, gate was declined, or legacy seen. */
export function shouldSkipInit(storageKey: string): boolean {
  const v = getRaw(storageKey);
  if (v === null) return false;
  if (v === VALUE_DECLINED) return true;
  return isOpenedValue(v);
}

/** True if this session already opened the full quiz modal for the given article key (not declined-only). */
export function hasModalBeenConsumed(storageKey: string): boolean {
  return isOpenedValue(getRaw(storageKey));
}

/** Persists “full modal opened” so reloads skip triggers; safe no-op if storage throws. */
export function markModalConsumed(storageKey: string): void {
  try {
    sessionStorage.setItem(storageKey, VALUE_OPENED);
  } catch {
    /* private mode / blocked */
  }
}

/** Persists intent-gate dismiss so neither gate nor full modal auto-shows again this tab session. */
export function markIntentGateDeclined(storageKey: string): void {
  try {
    sessionStorage.setItem(storageKey, VALUE_DECLINED);
  } catch {
    /* private mode / blocked */
  }
}
